import * as types from '../actions/actionTypes';

const defaultState = {
  history: [],
  pagination: {},
};

export default (state = defaultState, action) => {
  const nextState = Object.assign({}, state);
  switch (action.type) {
    case types.GET_ORDER_HISTORY:
      return { ...state, ...action.data };
    case types.GET_ORDER_HISTORY_SUCCESS:
      return { ...state, ...action.data };
    default:
      return nextState;
  }
};
